import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "advanced-search",
  "data-cy": "advanced-search-modal"
}
const _hoisted_2 = { class: "advanced-search-project-management" }
const _hoisted_3 = { class: "dd-item-container" }
const _hoisted_4 = { class: "dd-item-icon" }
const _hoisted_5 = { class: "dd-item-text" }
const _hoisted_6 = { class: "dd-item-container" }
const _hoisted_7 = { class: "dd-item-icon" }
const _hoisted_8 = { class: "dd-item-text" }
const _hoisted_9 = { class: "advanced-search-cta" }
const _hoisted_10 = { class: "dd-item-container" }
const _hoisted_11 = { class: "dd-item-icon" }
const _hoisted_12 = { class: "dd-item-text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = {
  class: "tabs-wrapper",
  "data-cy": "advanced-search-tabs"
}
const _hoisted_19 = {
  key: 0,
  class: "advanced-search-editor-updated-on"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "debug-mode-banner" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "debug-mode-title" }, "DEBUG", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 1,
  class: "advanced-search-results",
  "data-cy": "advanced-search-results"
}
const _hoisted_25 = { class: "spinner-search-results" }
const _hoisted_26 = {
  key: 0,
  class: "advanced-search-results-table"
}
const _hoisted_27 = { class: "advanced-search-results-table-header" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "table-header-cell icon-cell" }, null, -1)
const _hoisted_29 = { class: "table-cell-text" }
const _hoisted_30 = {
  key: 0,
  class: "table-header-cell-indicator"
}
const _hoisted_31 = { class: "table-cell-text" }
const _hoisted_32 = {
  key: 0,
  class: "table-header-cell-indicator"
}
const _hoisted_33 = { class: "table-cell-text" }
const _hoisted_34 = {
  key: 0,
  class: "table-header-cell-indicator"
}
const _hoisted_35 = { class: "table-cell-text" }
const _hoisted_36 = {
  key: 0,
  class: "table-header-cell-indicator"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = { class: "results-table-cell icon-cell" }
const _hoisted_39 = { class: "results-table-cell status-cell" }
const _hoisted_40 = { class: "results-table-cell article-no-cell" }
const _hoisted_41 = { class: "results-table-cell name-cell" }
const _hoisted_42 = { class: "results-table-cell variation-group-cell" }
const _hoisted_43 = {
  key: 2,
  class: "advanced-search-excel-edit"
}
const _hoisted_44 = { class: "spinner-container" }

import MSelect from "@/BasicComponentLibrary/MSelect.vue";
import MSelectItem from "@/BasicComponentLibrary/MSelectItem.vue";
import OpenSearches from "@AdvancedSearch/components/OpenSearches.vue";
import SearchRenameModal from "@AdvancedSearch/views/SearchRenameModal.vue";
import { AttributeDataTypes } from "@AttributeManager/configurations/AttributeTypeDataTypes";
import excelEditEditor from "@ContentEditor/components/ExcelEdit/ExcelEditEditor.vue";
import Alert from "@common/components/Alert.vue";
import confirmationModal from "@common/components/ConfirmationModal.vue";
import Icon from "@common/components/Icon.vue";
import MenuBar from "@common/components/MenuBar/MenuBar.vue";
import Spinner from "@common/components/Spinner.vue";
import { useToast } from "@common/composable/toast";
import { useFiles } from "@common/composable/useFiles";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { useLicenses, useUser } from "@common/composable/useRootStore";
import {
  AdvArticleResult,
  AdvancedSearchAction,
  AdvancedSearchActionType,
  AdvancedSearchEntry,
  AdvancedSearchFetchedEntry,
  ErrorItem,
  NewAdvancedSearchEntry
} from "@medapro-types/AdvancedSearch/AdvancedSearch";
import { BaseQueryBuilderGroup, QueryBuilderData, QueryBuilderRule } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import { ApiErrorData, MutableRequired } from "@medapro-types/common/common";
import { RootState, User } from "@medapro-types/common/rootstate";
import advancedSearchApi from "@services/advancedSearch";
import endpoints from "@services/endpoints";
import userTasksApi from "@services/userTasks";
import { getDateTimeText } from "@util/dateTimeUtils";
import { BaseIds } from "@util/enums/base-ids";
import { generateNewName } from "@util/generateNewName";
import { Guid } from "@util/guid";
import { naturalSort } from "@util/naturalSort";
import { UseVirtualList } from "@vueuse/components";
import _ from "lodash";
import moment from "moment";
import { sha1 as hash } from "object-hash";
import { computed, nextTick, onMounted, provide, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useState } from "vuex-composition-helpers";
import QueryBuilder from "../components//QueryBuilder/QueryBuilder.vue";
import EmptyState from "@common/components/EmptyState.vue";

//#region General
//configureCompat({ COMPONENT_ASYNC: false });
type ViewModel = {
  baseCatalogId: string | undefined;
  selectedSearch: AdvancedSearchEntry | NewAdvancedSearchEntry | undefined;
  articleSearches: AdvancedSearchEntry[];
  resultList: Array<AdvArticleResult>;
  initialSearch: AdvancedSearchEntry | null;
  errors: ErrorItem[];
  draftSearch: AdvancedSearchEntry | null;
  savedSearches: AdvancedSearchEntry[];
  busy: boolean;
  isSearchRunning: boolean;
  sortedBy: { desc: boolean; column: keyof AdvArticleResult & string } | null;
  primaryAction: AdvancedSearchAction | null;
  secondaryActions: (AdvancedSearchAction | null)[];
};
enum Tabs {
  editor,
  results,
  excelEdit
}

enum SearchRenameModalModes {
  "rename",
  "saveAs",
  "create"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AdvancedSearch',
  props: {
    hideExcelEdit: { type: Boolean },
    catalogId: {},
    advancedSearchId: {},
    executeSearchOnStart: { type: Boolean },
    resultCount: {}
  },
  emits: ["hide", "update:advancedSearchId", "update:resultCount"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;

const { t: $t, te: $te } = useI18n();
const router = useRouter();
const route = useRoute();


const { createToast } = useToast();
const userConfirmation = ref<typeof confirmationModal>();
const { triggerFileDownloadViaEndpoint } = useFiles();
//#endregion

//#region Store
const { user } = useUser();
const { meta } = useState<RootState>(["meta"]);
const { primaryLanguageCode } = useContentLanguages();

const { licenses } = useLicenses();
const isWorkManagerLicensed = computed(() => licenses.value?.WorkManager === "Licensed");

//#endregion

//#region Refs
const advancedSearch = ref<HTMLDivElement | null>(null);
const querybuilder = ref<HTMLDivElement | null>(null);
//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  baseCatalogId: undefined,
  selectedSearch: undefined,
  articleSearches: [],
  resultList: [],
  initialSearch: null,
  errors: [],
  draftSearch: null,
  savedSearches: [],
  busy: false,
  isSearchRunning: false,
  sortedBy: null,
  primaryAction: null,
  secondaryActions: []
});
const isBusyCreatingTask = ref(false);

const modals = reactive({ rename: false, open: false });

const states = reactive({ currentTab: Tabs.editor, isDirty: false, isBusy: false, searchRenameModalMode: SearchRenameModalModes.rename });

//#endregion

//#region Busy

provide("advancedSearchIsBusy", states.isBusy);

//#endregion

//#region Results

const setSortBy = async (columnName: keyof AdvArticleResult & string) => {
  if (vm.resultList.length > 0) {
    if (vm.sortedBy?.column == columnName) {
      vm.sortedBy.desc = !vm.sortedBy.desc;
    } else {
      vm.sortedBy = { column: columnName, desc: false };
    }

    sortResults();
  }
};

const sortResults = () => {
  vm.resultList = vm.sortedBy ? naturalSort(vm.resultList, vm.sortedBy.column, vm.sortedBy?.desc) : vm.resultList;
};

const canSaveSearch = computed<boolean>(() => {
  // Implmement check for user permissions etc. here
  return states.isDirty;
});

const saveSearch = async () => {
  if (canSaveSearch.value && states.isDirty) await saveArticleSearch();
};

const saveAsSearch = async () => {
  saveAsArticleSearch();
};

const saveAndRunSearch = async () => {
  await saveSearch();
  await runSearch();

  setSaveRunActionAsPrimary();
};

const runSearch = async () => {
  if (states.isDirty) return;

  vm.isSearchRunning = true;
  vm.resultList = [];
  states.currentTab = Tabs.results;
  let fetchedData: AdvArticleResult[] = [];

  if (vm.selectedSearch && vm.errors.length == 0) {
    try {
      states.isBusy = true;
      fetchedData = await advancedSearchApi.execute({
        advancedSearchId: vm.selectedSearch.advancedSearchId,
        catalogId: props.catalogId ?? vm.baseCatalogId ?? "00000000-0000-0000-0000-000000000000", // If catalogId is empty , search will execute on <Basiskatalog>
        language: primaryLanguageCode.value,
        returnArticleNo: true,
        returnLocalizedNames: true,
        returnState: true,
        orderDirection: false,
        orderByColumn: "name"
      });
    } catch (error: any) {
      if (error && error.isAxiosError) {
        if (error.response.status === 409) {
          let errorText = "";
          if (error.response.data.error == "UnknownSearchType") {
            errorText = $t("api.errors.AdvancedSearch." + error.response.data.error, [$t(`AdvancedSearch.SearchType.${error.response.data.args}`)]);
          }
          if (error.response.data.error == "UnknownOperatorForDataType") {
            const data = AttributeDataTypes.find((type) => type.key === error.response.data.args[0]);
            if (data) {
              error.response.data.args[0] = $t(data.name);
            }

            errorText = $t("api.errors.AdvancedSearch." + error.response.data.error, error.response.data.args);
          } else {
            errorText = $t("api.errors.AdvancedSearch." + error.response.data.error, error.response.data.args) ?? error.response.data.error;
          }

          createToast({
            text: errorText,
            title: $t("Error"),
            variant: "danger",
            titleIcon: "AdvancedSearch",
            textIllustration: "AdvancedSearch",
            statusTextIcon: "XCircleSolid"
          });
        }
      }
    } finally {
      states.isBusy = false;
      if (vm.busy) vm.busy = false;
    }
  }

  vm.resultList = fetchedData;
  vm.sortedBy = null;

  setRunActionAsPrimary();
};

const callToActions = reactive<Record<AdvancedSearchActionType, AdvancedSearchAction>>({
  run: {
    type: "run",
    text: $t("runSearch"),
    icon: "Play",
    clickHandler: runSearch
  },
  save: {
    type: "save",
    text: $t("Save"),
    icon: "Save",
    clickHandler: saveSearch
  },
  saveAs: {
    type: "saveAs",
    text: `${$t("saveAs")}...`,
    icon: "SaveAs",
    clickHandler: saveAsSearch
  },
  saveRun: {
    type: "saveRun",
    text: $t("saveAndRunSearch"),
    clickHandler: saveAndRunSearch
  }
});

const disabledMap = computed(() => ({
  run: states.isDirty,
  save: !canSaveSearch.value,
  saveRun: !canSaveSearch.value
}));

const navigateToContentEditor = (articleId: string) => {
  if (states.isDirty && !confirm($t("confirm.hasUnsavedData"))) return;
  states.isBusy = true;
  states.isDirty = false;

  nextTick(() => {
    router.push({ name: "article-editor", params: { id: articleId } });
    states.isBusy = false;
    emits("hide");
  });
};

//#endregion

//#region Exports

const runCsvExport = async () => {
  if (states.isDirty && !confirm($t("unsavedDataCantbeConsidered"))) return;
  if (vm.selectedSearch) {
    try {
      const response = await advancedSearchApi.exportToCsv(vm.selectedSearch.advancedSearchId, primaryLanguageCode.value);
      if (response != null) {
        triggerFileDownloadViaEndpoint(endpoints.advancedSearch.downloadCsv, {
          token: response,
          prefixName: encodeURIComponent(vm.selectedSearch.name)
        });
      }
    } catch (error: any) {
      if (error && error.isAxiosError) {
        if (error.response.status === 409) {
          let errorText = "";
          if (error.response.data.error == "UnknownSearchType") {
            errorText = $t("api.errors.AdvancedSearch." + error.response.data.error, [$t(`AdvancedSearch.SearchType.${error.response.data.args}`)]);
          }
          if (error.response.data.error == "UnknownOperatorForDataType") {
            const data = AttributeDataTypes.find((type) => type.key === error.response.data.args[0]);
            if (data) {
              error.response.data.args[0] = $t(data.name);
            }

            errorText = $t("api.errors.AdvancedSearch." + error.response.data.error, error.response.data.args);
          } else {
            errorText = $t("api.errors.AdvancedSearch." + error.response.data.error, error.response.data.args) ?? error.response.data.error;
          }

          createToast({
            text: errorText,
            title: $t("Error"),
            variant: "danger",
            titleIcon: "AdvancedSearch",
            textIllustration: "AdvancedSearch",
            statusTextIcon: "XCircleSolid"
          });
        }
      }
    } finally {
      states.isBusy = false;
      if (vm.busy) vm.busy = false;
    }
  }
};

//#endregion

//#region TypeGuard
function isNewAdvancedSearchEntry(e: AdvancedSearchEntry | NewAdvancedSearchEntry | undefined): e is NewAdvancedSearchEntry {
  return !!e && Object.hasOwn(e, "isNew");
}
const isQueryBuilderGroup = (e: unknown): e is BaseQueryBuilderGroup => {
  return !!e && Object.hasOwn(e, "groupId") && Object.hasOwn(e, "logic") && Object.hasOwn(e, "rules") && Object.hasOwn(e, "groups");
};
const isQueryBuilderRule = (e: unknown): e is QueryBuilderRule => {
  return !!e && Object.hasOwn(e, "ruleId") && Object.hasOwn(e, "searchType") && Object.hasOwn(e, "value");
};
//#endregion

//#region advSearches CRUD
const sortedSearches = computed(() => {
  return naturalSort(vm.articleSearches, (x) => x.name);
});

const selectSearch = (item: AdvancedSearchFetchedEntry | AdvancedSearchEntry, setDirty = false) => {
  if (item.advancedSearchId != vm.selectedSearch?.advancedSearchId) {
    if (states.isDirty && !confirm($t("confirm.hasUnsavedData"))) return;
    states.isBusy = true;
    vm.draftSearch = null;

    if (vm.selectedSearch && vm.initialSearch) {
      Object.assign(vm.selectedSearch, vm.initialSearch);
    }

    if (isNewAdvancedSearchEntry(vm.selectedSearch) && vm.selectedSearch.isNew && states.isDirty) {
      vm.articleSearches = _.filter(vm.articleSearches, (x) => !(isNewAdvancedSearchEntry(x) && x.isNew));
    }

    if (_.isString(item.searchJson)) {
      vm.initialSearch = _.cloneDeep(item);
      vm.selectedSearch = Object.assign(item, { searchJson: JSON.parse(item.searchJson) });
    } else {
      vm.initialSearch = _.cloneDeep(item);
      vm.selectedSearch = item;
    }

    vm.resultList = [];
    nextTick(() => {
      states.isDirty = setDirty;
      states.isBusy = false;
    });
  }
};

const loadAdvSearches = async () => {
  states.isBusy = true;

  try {
    vm.articleSearches = await advancedSearchApi.getAll();
    vm.savedSearches = _.cloneDeep(vm.articleSearches);
  } catch (error) {
    console.error("Error during fetching of Searches occured: ", error);
  } finally {
    states.isBusy = false;
  }
};

const createNewArticleSearch = () => {
  const currentUser = user.value;

  const newSearch: NewAdvancedSearchEntry = {
    advancedSearchId: Guid.new(),
    name: `${generateNewName($t("newSearch"), vm.savedSearches)}`,
    searchJson: {},
    createdBy: currentUser.username,
    updatedBy: currentUser.username,
    createdOn: moment().format("YYYY-MM-DD HH:mm:ss"),
    updatedOn: moment().format("YYYY-MM-DD HH:mm:ss"),
    isNew: true
  };
  states.currentTab = Tabs.editor;
  vm.draftSearch = newSearch;
  nextTick(() => {
    states.searchRenameModalMode = SearchRenameModalModes.create;
    showRenameModal();
  });
};

const showRenameModal = () => {
  if (!vm.draftSearch) return;
  modals.rename = true;
};

const updateSearch = async (/* newName: string */) => {
  if (states.searchRenameModalMode != SearchRenameModalModes.rename) {
    if (!vm.draftSearch) return;

    states.currentTab = Tabs.editor;
    vm.articleSearches.push(vm.draftSearch);
    vm.selectedSearch = vm.draftSearch;
    states.isDirty = true;
    if (states.searchRenameModalMode === SearchRenameModalModes.saveAs) {
      await saveArticleSearch();
    }
  } else {
    states.isDirty = true;
  }
  vm.draftSearch = null;
};

const cancelRename = () => {
  vm.draftSearch = null;
  if (vm.selectedSearch === undefined && states.searchRenameModalMode === SearchRenameModalModes.create) {
    emits("hide");
  }
};

const assignNewIdsinSearchJson = (jsonObj: QueryBuilderData | BaseQueryBuilderGroup | QueryBuilderRule) => {
  if (isQueryBuilderGroup(jsonObj)) {
    for (const group of jsonObj.groups) {
      assignNewIdsinSearchJson(group);
    }
    for (const rule of jsonObj.rules) {
      assignNewIdsinSearchJson(rule);
    }
  }
  if (isQueryBuilderGroup(jsonObj)) jsonObj.groupId = Guid.new();
  if (isQueryBuilderRule(jsonObj)) jsonObj.ruleId = Guid.new();
};

const deleteArticleSearch = async () => {
  if (vm.selectedSearch) {
    try {
      if (!isNewAdvancedSearchEntry(vm.selectedSearch)) {
        const response = await advancedSearchApi.canDelete(vm.selectedSearch.advancedSearchId, primaryLanguageCode.value);
        if (response != null) {
          if (response.canDelete) {
            if (confirm($t("confirm.searchDelete", { selectedSearch: vm.selectedSearch.name })))
              await advancedSearchApi.delete(vm.selectedSearch.advancedSearchId);
            else return;
          } else {
            const names = response.catalogNames || [];
            const visibleNames = names.slice(0, 3).join("\n");
            const catalogNames = `${visibleNames} ${names.length > 3 ? $t("confirm.andOthers", { count: names.length - 3 }) : ""}`;

            const confirmation = await getDeleteConfirmation(catalogNames);
            if (confirmation) await advancedSearchApi.delete(vm.selectedSearch.advancedSearchId);
            else return;
          }
        }
      } else {
        if (!confirm($t("confirm.searchDelete", { selectedSearch: vm.selectedSearch.name }))) return;
      }
      _.remove(vm.articleSearches, (x) => x == vm.selectedSearch);
      vm.savedSearches = _.cloneDeep(vm.articleSearches);
      states.isDirty = false;
      selectFirstOrCreate();
    } catch (error) {
      console.error("Error deleting search:", error);
    }
  }
};

const getDeleteConfirmation = async (catalogNames: string) => {
  let confirmation = false;
  try {
    await userConfirmation.value?.getConfirmation($t("confirm.deleteArticleFilter"), $t("confirm.canNotDeleteSearch", { catalogNames: catalogNames }), false);
    confirmation = true;
  } catch (e) {
    console.log("Error during confirmation:", e);
  }
  return confirmation;
};

const saveArticleSearch = async () => {
  if (vm.selectedSearch) {
    try {
      const searchJSON = removeUnnecessaryProperties(_.cloneDeep(vm.selectedSearch.searchJson));
      await advancedSearchApi.save({
        advancedSearchId: vm.selectedSearch.advancedSearchId,
        name: vm.selectedSearch.name,
        searchJson: searchJSON
      });
      if (isNewAdvancedSearchEntry(vm.selectedSearch)) delete vm.selectedSearch.isNew;
      vm.savedSearches = _.cloneDeep(vm.articleSearches);
      states.isDirty = false;
      vm.selectedSearch.updatedOn = moment().toISOString();
      vm.initialSearch = _.cloneDeep(vm.selectedSearch);
      vm.errors = [];
    } catch (error: any) {
      handleErrors(error);
    }
  }
};

const removeUnnecessaryProperties = (obj: QueryBuilderData) => {
  return _.cloneDeepWith(obj, (value) => {
    if (isQueryBuilderRule(value)) {
      delete value.dataUIType;
      if (!value.attributeId) delete value.attributeId;
      if (!value.dataLanguage) delete value.dataLanguage;
    }
  });
};

const renameSearch = () => {
  if (vm.selectedSearch) {
    vm.draftSearch = vm.selectedSearch;
    states.searchRenameModalMode = SearchRenameModalModes.rename;
    showRenameModal();
  }
};

const saveAsArticleSearch = () => {
  const currentUser: User = { ...user.value } as MutableRequired<User>;

  const searchJsonCopy = _.cloneDeep(vm.selectedSearch?.searchJson) ?? {};

  assignNewIdsinSearchJson(searchJsonCopy);

  vm.draftSearch = vm.selectedSearch
    ? Object.assign(_.cloneDeep(vm.selectedSearch), {
        advancedSearchId: Guid.new(),
        searchJson: searchJsonCopy,
        createdBy: currentUser,
        updatedBy: currentUser,
        createdOn: moment().format("YYYY-MM-DD HH:mm:ss"),
        updatedOn: moment().format("YYYY-MM-DD HH:mm:ss")
      })
    : null;

  if (states.isDirty) {
    if (!confirm($t("confirm.hasUnsavedData"))) {
      vm.draftSearch = null;
      return;
    }

    /*  if (isNewAdvancedSearchEntry(vm.selectedSearch)) {
      _.remove(vm.articleSearches, (x) => x === vm.selectedSearch);
    } else if (vm.tempName != "" && vm.selectedSearch) {
      vm.selectedSearch.name = vm.tempName;
    } */
  }

  states.searchRenameModalMode = SearchRenameModalModes.saveAs;
  showRenameModal();
};

async function createTask() {
  if (vm.selectedSearch) {
    try {
      isBusyCreatingTask.value = true;
      const newTaskId = await userTasksApi.createUserTaskFromAdvancedSearch(vm.selectedSearch.advancedSearchId);
      if (newTaskId) {
        const query = !route.fullPath.includes("work-manager") ? { back: route.fullPath } : {};
        nextTick(() => {
          router.push({ name: "task-item", params: { id: newTaskId }, query });
          emits("hide");
        });
      }
    } catch (error: any) {
      let errorMessage = $t("ErrorMessage.TaskCreationFailed");
      if (error && error.isAxiosError) {
        if (error.response.status === 409) {
          errorMessage = $te(`api.errors.AdvancedSearch.${error?.response?.data.error}`)
            ? $t(`api.errors.AdvancedSearch.${error?.response?.data.error}`)
            : error?.response?.data.error;
        }
      }
      createToast({
        text: errorMessage,
        title: $t("Error"),
        variant: "danger",
        titleIcon: "AdvancedSearch",
        textIllustration: "AdvancedSearch",
        statusTextIcon: "XCircleSolid"
      });
    } finally {
      isBusyCreatingTask.value = false;
    }
  }
}

const selectFirstOrCreate = async () => {
  if (sortedSearches.value.length) {
    let selectedElement: AdvancedSearchEntry | AdvancedSearchFetchedEntry | undefined;
    if (props.advancedSearchId) {
      selectedElement = sortedSearches.value.find((search) => search.advancedSearchId === props.advancedSearchId);
    } else {
      selectedElement = _.first(sortedSearches.value);
    }

    if (selectedElement) selectSearch(selectedElement);
  } else {
    createNewArticleSearch();
  }
};

watch(
  () => vm.selectedSearch,
  (nv) => {
    if (nv) {
      emits("update:advancedSearchId", nv.advancedSearchId);
    }
  },
  { deep: true }
);

watch(
  () => vm.selectedSearch?.name,
  () => {
    vm.isSearchRunning = false;
  }
);

watch(
  () => states.isDirty,
  (nv, ov) => {
    if (vm.primaryAction?.type === "saveRun") {
      return;
    }
    if (nv === true && ov === false) {
      setSaveActionAsPrimary();
      return;
    }
    setRunActionAsPrimary();
  }
);

watch(
  () => vm.selectedSearch?.searchJson,
  (nv) => {
    if (nv && vm.initialSearch && !states.isDirty) {
      const newJsonHash = hash(nv);
      const oldJsonHash = hash(vm.initialSearch.searchJson!);
      if (newJsonHash != oldJsonHash) states.isDirty = true;
    }
  },
  { deep: true }
);

watch(
  () => vm.resultList,
  () => {
    if (states.currentTab == Tabs.results) {
      emits("update:resultCount", vm.resultList?.length);
    } else {
      emits("update:resultCount", null);
    }
  }
);

watch(
  () => states.currentTab,
  () => {
    if (states.currentTab == Tabs.results) {
      emits("update:resultCount", vm.resultList?.length);
    } else {
      emits("update:resultCount", null);
    }
  }
);
//#endregion

//#region SearchRenameModal
const searchRenameModalTitle = computed(() => {
  switch (states.searchRenameModalMode) {
    case SearchRenameModalModes.create:
      return $t("SearchRenameModal.create");

    case SearchRenameModalModes.rename:
      return $t("SearchRenameModal.rename");

    case SearchRenameModalModes.saveAs:
      return $t("SearchRenameModal.saveAs");
  }
  return "";
});
const searchRenameModalOkButtonText = computed(() => {
  switch (states.searchRenameModalMode) {
    case SearchRenameModalModes.rename:
      return $t("Rename");
    case SearchRenameModalModes.saveAs:
      return $t("Save");
    case SearchRenameModalModes.create:
      return $t("Add");
  }

  return "";
});
//#endregion

//#region LifeCycle

onMounted(async () => {
  vm.baseCatalogId = BaseIds.BaseCatalog;
  await loadAdvSearches();
  selectFirstOrCreate();

  if (props.executeSearchOnStart) {
    vm.busy = true;
    saveAndRunSearch();
  }

  setRunActionAsPrimary();
});

//#endregion

//#region Exposed

__expose({ states });

//#endregion

//#region Debug-Functions
const debugMode = ref(false);

const canActivateDebug = computed(() => {
  return false;
});
//#endregion

//#region Depth - Calculation
const getMaxDepth = (groups: BaseQueryBuilderGroup[], depth = 1): number => {
  if (!groups || groups.length === 0) return depth;
  return Math.max(...groups.map((group: BaseQueryBuilderGroup) => getMaxDepth(group.groups, depth + 1)));
};

const maxDepth = computed(() => getMaxDepth(isQueryBuilderGroup(vm.selectedSearch?.searchJson) ? vm.selectedSearch.searchJson.groups : []));
//#endregion

//#region Validation
function handleErrors(error: any) {
  vm.errors = [];
  const responseData = error.response?.data;
  if (error && error.isAxiosError && error.response.status === 400) {
    if (responseData?.Name[0]) {
      createToast({
        text: $t("api.errors.AdvancedSearch." + responseData?.Name[0]),
        title: $t("Error"),
        variant: "danger",
        titleIcon: "AdvancedSearch",
        textIllustration: "AdvancedSearch",
        statusTextIcon: "XCircleSolid"
      });
    }
  }
  if (Object.hasOwn(responseData, "errors")) {
    responseData.errors.forEach((entry: ApiErrorData) => {
      if (entry?.error) {
        const errorItem: ErrorItem = { ruleId: Guid.isGuid(entry.value) ? entry.value : null, error: entry?.error, message: entry?.message };
        vm.errors.push(errorItem);
      }
    });
  }
  if (Object.hasOwn(responseData, "error")) {
    vm.errors.push(responseData?.error);
  }
}

function getErrorLocalized(error: ErrorItem): string {
  if (_.isString(error)) return $t(`api.errors.AdvancedSearch.${error}`);
  if (!Guid.isGuid(error.ruleId)) return $t(`api.errors.AdvancedSearch.${error.error}`);

  const rule = findRuleById(vm.selectedSearch?.searchJson, error.ruleId);
  if (!isQueryBuilderRule(rule)) {
    vm.errors = [];
    return "";
  }
  if (rule.ruleId) rule.ruleId;
  const errorMessage = $t(`api.errors.AdvancedSearch.${error.error}`);
  const searchTypeLocalized = $t(`AdvancedSearch.SearchType.${rule.searchType}`);
  return `${errorMessage} (${searchTypeLocalized})`;
}

function findRuleById(group: BaseQueryBuilderGroup | unknown, id: Guid): QueryBuilderRule | null {
  if (!isQueryBuilderGroup(group)) return null;

  const rule = group.rules.find((rule) => rule.ruleId === id);
  if (rule) return rule;

  for (const subGroup of group.groups) {
    const foundInSubGroup = findRuleById(subGroup, id);
    if (foundInSubGroup) return foundInSubGroup;
  }

  return null;
}

function setRunActionAsPrimary() {
  vm.primaryAction = callToActions.run;
  vm.secondaryActions = [callToActions.save, callToActions.saveAs, null, callToActions.saveRun];
}

function setSaveActionAsPrimary() {
  vm.primaryAction = callToActions.save;
  vm.secondaryActions = [callToActions.saveAs, null, callToActions.saveRun];
}

function setSaveRunActionAsPrimary() {
  vm.primaryAction = callToActions.saveRun;
  vm.secondaryActions = [callToActions.run, null, callToActions.save, callToActions.saveAs];
}
//#endregion;

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_tab = _resolveComponent("b-tab")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_b_checkbox = _resolveComponent("b-checkbox")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(MenuBar, { "without-border": "" }, {
          leftItems: _withCtx(() => [
            _createVNode(MSelect, {
              class: "project-selection-dd",
              "data-cy": "project-selection-dd",
              modelValue: vm.selectedSearch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.selectedSearch) = $event)),
              items: sortedSearches.value
            }, {
              "button-content": _withCtx(() => [
                _createTextVNode(_toDisplayString(vm.selectedSearch?.name) + " ", 1),
                (states.isDirty)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(`(${_unref($t)("unsaved")})`), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedSearches.value, (item) => {
                  return (_openBlock(), _createBlock(MSelectItem, {
                    key: item.advancedSearchId,
                    "data-cy": 'select-menu-entry-' + item.name,
                    active: vm.selectedSearch?.advancedSearchId == item.advancedSearchId,
                    onClick: ($event: any) => (selectSearch(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-cy", "active", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "items"]),
            _withDirectives((_openBlock(), _createBlock(_component_b_btn, {
              class: "btn-icon mono",
              "data-cy": "advance-search-new-btn",
              onClick: createNewArticleSearch
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, { icon: "Plus" })
              ]),
              _: 1
            })), [
              [_directive_tooltip, _unref($t)('add')]
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_b_btn, {
              class: "btn-icon mono",
              "data-cy": "advanced-search-open-btn",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (modals.open = true))
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, { icon: "Open" })
              ]),
              _: 1
            })), [
              [
                _directive_tooltip,
                _unref($t)('Open'),
                void 0,
                { hover: true }
              ]
            ]),
            _createVNode(_component_b_dropdown, {
              "toggle-class": "btn-icon mono",
              "no-caret": "",
              "data-cy": "advanced-search-more-ddn"
            }, {
              "button-content": _withCtx(() => [
                _createVNode(Icon, { icon: "Options" })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_b_dropdown_item, {
                  "link-class": "icon-item",
                  "data-cy": "advance-search-delete-btn",
                  onClick: _withModifiers(deleteArticleSearch, ["prevent"]),
                  disabled: vm.articleSearches.length == 1 && vm.savedSearches.length == 0
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", _hoisted_4, [
                        _createVNode(Icon, { icon: "Delete" })
                      ]),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref($t)("delete")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_b_dropdown_item, {
                  "link-class": "icon-item",
                  onClick: _withModifiers(renameSearch, ["prevent"]),
                  disabled: !vm.articleSearches
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, [
                        _createVNode(Icon, { icon: "Rename" })
                      ]),
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref($t)("Rename")), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          rightItems: _withCtx(() => [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_b_btn, {
                class: "btn btn-with-icon",
                variant: "primary",
                onClick: vm.primaryAction?.clickHandler,
                "data-cy": "advance-search-primary-btn"
              }, {
                default: _withCtx(() => [
                  (vm.primaryAction?.icon)
                    ? (_openBlock(), _createBlock(Icon, {
                        key: 0,
                        icon: vm.primaryAction?.icon
                      }, null, 8, ["icon"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(vm.primaryAction?.text), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_b_dropdown, {
                "toggle-class": "btn-icon",
                variant: "primary",
                "data-cy": "advance-search-primary-ddn",
                right: "",
                "no-caret": ""
              }, {
                "button-content": _withCtx(() => [
                  _createVNode(Icon, { icon: "ChevronBottom" })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.secondaryActions, (entry, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      entry
                        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                            key: 0,
                            "link-class": "icon-item",
                            disabled: disabledMap.value[entry.type],
                            onClick: _withModifiers(entry.clickHandler, ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("span", _hoisted_11, [
                                  (entry?.icon)
                                    ? (_openBlock(), _createBlock(Icon, {
                                        key: 0,
                                        icon: entry?.icon
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(entry.text), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["disabled", "onClick"]))
                        : (_openBlock(), _createBlock(_component_b_dropdown_divider, { key: 1 }))
                    ]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", null, [
              _createVNode(_component_b_btn, {
                class: "btn-with-icon mono",
                disabled: states.isDirty,
                onClick: runCsvExport,
                "data-cy": "advance-search-download-btn"
              }, {
                default: _withCtx(() => [
                  _createVNode(Icon, { icon: "Download" }),
                  _createTextVNode(" " + _toDisplayString(_unref($t)("exportAsCSV")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])), [
              [_directive_tooltip, states.isDirty ? _unref($t)('AdvancedSearch.needsSave') : '']
            ]),
            (isWorkManagerLicensed.value)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createVNode(_component_b_btn, {
                    class: "btn-with-icon mono",
                    "data-cy": "advance-search-create-task-btn",
                    onClick: _withModifiers(createTask, ["prevent"]),
                    disabled: states.isDirty || isBusyCreatingTask.value
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(Icon, { icon: "AddTask" }, null, 512), [
                        [_vShow, !isBusyCreatingTask.value]
                      ]),
                      _withDirectives(_createVNode(Spinner, { size: "16" }, null, 512), [
                        [_vShow, isBusyCreatingTask.value]
                      ]),
                      _createTextVNode(" " + _toDisplayString(_unref($t)("contextMenu.createTask")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick", "disabled"])
                ])), [
                  [_directive_tooltip, states.isDirty ? _unref($t)('AdvancedSearch.needsSave') : '']
                ])
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(OpenSearches, {
          modelValue: modals.open,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((modals.open) = $event)),
          searches: sortedSearches.value,
          onConfirm: selectSearch
        }, null, 8, ["modelValue", "searches"]),
        (vm.draftSearch)
          ? (_openBlock(), _createBlock(SearchRenameModal, {
              key: 0,
              modelValue: vm.draftSearch.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((vm.draftSearch.name) = $event)),
              show: modals.rename,
              "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((modals.rename) = $event)),
              selectedSearchId: vm.draftSearch.advancedSearchId,
              title: searchRenameModalTitle.value,
              "ok-button-text": searchRenameModalOkButtonText.value,
              "max-characters-name": 128,
              "saved-search-list": vm.savedSearches,
              onConfirm: updateSearch,
              onCancel: cancelRename
            }, null, 8, ["modelValue", "show", "selectedSearchId", "title", "ok-button-text", "saved-search-list"]))
          : _createCommentVNode("", true),
        (vm.errors.length > 0 || maxDepth.value > _unref(meta).config.advancedSearchMaxDepthAllowed)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["error-area", { show: vm.errors.length > 0 || maxDepth.value > _unref(meta).config.advancedSearchMaxDepthAllowed }])
            }, [
              (vm.errors.length === 1)
                ? (_openBlock(), _createBlock(Alert, {
                    key: 0,
                    class: "m-0",
                    show: "",
                    variant: "danger"
                  }, {
                    default: _withCtx(() => [
                      (vm.errors.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(getErrorLocalized(vm.errors[0])), 1))
                        : (maxDepth.value > _unref(meta).config.advancedSearchMaxDepthAllowed)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_unref($t)("api.errors.AdvancedSearch.MaxGroupLevelExceeded")), 1))
                          : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(Alert, {
                    key: 1,
                    class: "w-100",
                    "with-icon": "",
                    show: "",
                    variant: "danger"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_unref($t)("AdvancedSearch.Errors", { count: vm.errors.length })) + " ", 1),
                        _withDirectives((_openBlock(), _createBlock(_component_b_btn, {
                          size: "sm",
                          variant: "link",
                          class: "ml-1"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref($t)("show")), 1)
                          ]),
                          _: 1
                        })), [
                          [
                            _directive_b_modal,
                            void 0,
                            void 0,
                            { "errors-overview": true }
                          ]
                        ])
                      ])
                    ]),
                    _: 1
                  })),
              _createVNode(_component_b_modal, {
                "header-close-content": "",
                id: "errors-overview",
                "ok-only": "",
                "ok-title": _unref($t)('Close'),
                title: _unref($t)('AdvancedSearch.ErrorOverview'),
                "body-class": "warnings-overview-modal overflow-auto"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(vm.errors, (entry) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: _unref(_).isString(entry) ? entry : entry.error
                    }, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(getErrorLocalized(entry)), 1)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["ok-title", "title"])
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_b_tabs, {
          modelValue: states.currentTab,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((states.currentTab) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_b_tab, {
              title: _unref($t)('editor')
            }, null, 8, ["title"]),
            _createVNode(_component_b_tab, {
              title: _unref($t)('results')
            }, null, 8, ["title"]),
            (!props.hideExcelEdit)
              ? (_openBlock(), _createBlock(_component_b_tab, {
                  key: 0,
                  disabled: states.isDirty,
                  title: _unref($t)('catalogNode.excelEdit')
                }, null, 8, ["disabled", "title"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (vm.selectedSearch && vm.selectedSearch.updatedOn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(Icon, { icon: "Clock" }),
              _createTextVNode(" " + _toDisplayString(_unref(getDateTimeText)(vm.selectedSearch.updatedOn)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      (states.currentTab == Tabs.editor)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["advanced-search-editor", { 'has-errors': vm.errors.length > 0 || maxDepth.value > _unref(meta).config.advancedSearchMaxDepthAllowed }]),
            "data-cy": "advanced-search-editor",
            ref_key: "advancedSearch",
            ref: advancedSearch
          }, [
            (vm.selectedSearch)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "advanced-search-editor-querybuilder-container",
                  ref_key: "querybuilder",
                  ref: querybuilder
                }, [
                  _createVNode(QueryBuilder, {
                    modelValue: vm.selectedSearch.searchJson,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((vm.selectedSearch.searchJson) = $event)),
                    isBusy: states.isBusy,
                    "onUpdate:isBusy": _cache[7] || (_cache[7] = ($event: any) => ((states.isBusy) = $event))
                  }, null, 8, ["modelValue", "isBusy"])
                ], 512))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref($t)("needToSelectAdvSearch")), 1)),
            (canActivateDebug.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  class: _normalizeClass(["debug-mode-wrapper", { active: debugMode.value }])
                }, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createVNode(_component_b_checkbox, {
                      class: "debug-mode-switch",
                      switch: "",
                      modelValue: debugMode.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((debugMode).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Show DataModel(DebugMode)")
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  (debugMode.value)
                    ? (_openBlock(), _createElementBlock("textarea", {
                        key: 0,
                        class: "debug-mode-textarea",
                        value: JSON.stringify(vm.selectedSearch?.searchJson, null, 4),
                        readonly: ""
                      }, " ", 8, _hoisted_23))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      (states.currentTab == Tabs.results)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _withDirectives(_createElementVNode("div", _hoisted_25, [
              _createVNode(Spinner)
            ], 512), [
              [_vShow, vm.busy]
            ]),
            (_openBlock(), _createElementBlock("div", {
              key: `sorted-${vm.sortedBy?.column}`
            }, [
              (vm.resultList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", {
                        class: "table-header-cell status-cell",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (setSortBy('stateSequence')))
                      }, [
                        _createElementVNode("div", _hoisted_29, _toDisplayString(_unref($t)("AdvancedSearch.result.status")), 1),
                        (vm.sortedBy?.column == 'stateSequence')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                              _createVNode(Icon, {
                                icon: vm.sortedBy?.desc ? 'ChevronBottom' : 'ChevronTop'
                              }, null, 8, ["icon"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "table-header-cell article-no-cell",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (setSortBy('articleNo')))
                      }, [
                        _createElementVNode("div", _hoisted_31, _toDisplayString(_unref($t)("AdvancedSearch.result.articleNo")), 1),
                        (vm.sortedBy?.column == 'articleNo')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                              _createVNode(Icon, {
                                icon: vm.sortedBy?.desc ? 'ChevronBottom' : 'ChevronTop'
                              }, null, 8, ["icon"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "table-header-cell name-cell",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (setSortBy('name')))
                      }, [
                        _createElementVNode("div", _hoisted_33, _toDisplayString(_unref($t)("AdvancedSearch.result.name")), 1),
                        (vm.sortedBy?.column == 'name')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _createVNode(Icon, {
                                icon: vm.sortedBy?.desc ? 'ChevronBottom' : 'ChevronTop'
                              }, null, 8, ["icon"])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", {
                        class: "table-header-cell variation-group-cell",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (setSortBy('variationGroupName')))
                      }, [
                        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref($t)("AdvancedSearch.result.variationGroupName")), 1),
                        (vm.sortedBy?.column == 'variationGroupName')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                              _createVNode(Icon, {
                                icon: vm.sortedBy?.desc ? 'ChevronBottom' : 'ChevronTop'
                              }, null, 8, ["icon"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createVNode(_unref(UseVirtualList), {
                      ref: "virtualList",
                      list: vm.resultList,
                      height: "calc(80vh - 190px)",
                      options: { itemHeight: 30 }
                    }, {
                      default: _withCtx(({ data: entry }) => [
                        _createElementVNode("div", {
                          class: "results-table-row",
                          onClick: ($event: any) => (navigateToContentEditor(entry?.articleId))
                        }, [
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(Icon, { icon: "Article" })
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            (entry?.stateColor)
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 0,
                                  class: "entry-status-color",
                                  style: _normalizeStyle({ backgroundColor: entry.stateColor })
                                }, null, 4))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("span", null, _toDisplayString(entry?.articleNo), 1)
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("span", {
                              class: _normalizeClass({ fallback: entry?.name_IsFallback })
                            }, _toDisplayString(entry?.name), 3)
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", {
                              class: _normalizeClass({ fallback: entry?.variationGroupName_IsFallback })
                            }, _toDisplayString(entry?.variationGroupName), 3)
                          ])
                        ], 8, _hoisted_37)
                      ]),
                      _: 1
                    }, 8, ["list"])
                  ]))
                : (_openBlock(), _createBlock(EmptyState, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(vm.isSearchRunning ? _unref($t)("AdvancedSearch.emptyResults") : _unref($t)("AdvancedSearch.noExecutionResults")), 1)
                    ]),
                    _: 1
                  }))
            ]))
          ]))
        : _createCommentVNode("", true),
      (states.currentTab == Tabs.excelEdit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            _createVNode(excelEditEditor, {
              ref: "excel-editor",
              isAdvancedSearchExcelEdit: "",
              advancedSearchId: vm.selectedSearch?.advancedSearchId,
              advancedSearchCatalogId: props.catalogId ?? vm.baseCatalogId,
              advancedSearchName: vm.selectedSearch?.name
            }, null, 8, ["advancedSearchId", "advancedSearchCatalogId", "advancedSearchName"])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !states.isBusy]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_44, [
      _createVNode(Spinner)
    ], 512), [
      [_vShow, states.isBusy]
    ]),
    _createElementVNode("div", null, [
      _createVNode(confirmationModal, {
        ref_key: "userConfirmation",
        ref: userConfirmation
      }, null, 512)
    ])
  ], 64))
}
}

})